<script setup lang="ts">
import type { StageSetup, ThankYouPage } from '@/types'

interface Props {
  stage: StageSetup
  thp?: ThankYouPage
}

const props = defineProps<Props>()
</script>

<template>
  <div
    class="ui-status-card"
    :style="{
      'background-color': stage.color
    }"
  >
    <div class="ui-status-card-info">
      <img
        v-if="stage.icon"
        :src="stage.icon"
        :alt="stage.title"
        ondragstart="return false"
        class="ui-status-card-info__icon"
      />

      <span class="ui-status-card-info__title">
        {{ thp?.title ? thp.title : stage.title }}
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variables';

.ui-status-card {
  width: 100%;
  padding: $font-size-base * 3;

  border-radius: 20px;

  margin-top: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  &-info {
    display: flex;
    align-items: center;

    gap: $font-size-base * 1.2;

    &__icon {
      width: 80px;
    }

    &__title {
      @include font-size(2rem, 600, 1.2);
    }
  }

  @media screen and (max-width: $breakpoint-lg) {
    &-info {
      gap: $font-size-base * 0.6;

      &__icon {
        width: 60px;
      }

      &__title {
        @include font-size(1.5rem, 600, 1.2);
      }
    }
  }
}
</style>
